import { servicePages } from '../../../mocks/service-pages';

export default function AllServicesContent() {
  return (
    <div id="all-services-content">
      {servicePages.map((service, index) => (
        <section
          key={service.slug}
          className={`py-24 ${index % 2 === 0 ? 'bg-white' : 'bg-stone-50'}`}
        >
          {/* Section label */}
          <div className="max-w-7xl mx-auto px-6 mb-12">
            <div className="flex items-center gap-4">
              <span className="text-amber-600 text-xs font-bold uppercase tracking-widest">
                {String(index + 1).padStart(2, '0')} / {String(servicePages.length).padStart(2, '0')}
              </span>
              <div className="h-px flex-1 bg-stone-200" />
            </div>
          </div>

          <div className="max-w-7xl mx-auto px-6">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-start ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              {/* Content side */}
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">
                  What&apos;s Included
                </span>
                <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-4 leading-tight">
                  {service.title}
                </h2>
                <p className="text-stone-500 text-lg leading-relaxed mb-3">
                  {service.tagline}
                </p>
                <p className="text-stone-500 text-base leading-relaxed mb-10">
                  {service.whatIncluded.subheadline}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {service.whatIncluded.items.map((item) => (
                    <div
                      key={item.title}
                      className="flex items-start gap-4 bg-white rounded-xl p-5 border border-stone-100"
                    >
                      <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                        <i className={`${item.icon} text-amber-600 text-lg`} />
                      </div>
                      <div>
                        <p className="font-semibold text-stone-900 text-sm mb-1">{item.title}</p>
                        <p className="text-stone-500 text-xs leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pricing preview */}
                <div className="mt-10 bg-stone-900 rounded-2xl p-6">
                  <p className="text-amber-400 text-xs font-bold uppercase tracking-widest mb-4">Pricing from</p>
                  <div className="grid grid-cols-3 gap-3">
                    {[
                      { label: 'Hourly', from: '$45', unit: '/hr' },
                      { label: 'Half-Day', from: '$165', unit: '/4hrs' },
                      { label: 'Full-Day', from: '$299', unit: '/day' },
                    ].map((tier) => (
                      <div key={tier.label} className="text-center bg-stone-800 rounded-xl p-4">
                        <p className="text-stone-400 text-xs mb-1">{tier.label}</p>
                        <p className="text-white font-bold text-lg font-serif">{tier.from}</p>
                        <p className="text-stone-500 text-xs">{tier.unit}</p>
                      </div>
                    ))}
                  </div>
                  <p className="text-stone-500 text-xs mt-4 text-center">
                    All equipment included • No hidden fees • Instant confirmation
                  </p>
                </div>
              </div>

              {/* Image side */}
              <div className={`relative ${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden h-[600px]">
                  <img
                    src={service.whatIncluded.sideImage}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl px-6 py-4 border border-stone-200">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-amber-500 text-xl" />
                    </div>
                    <div>
                      <p className="text-stone-900 font-semibold text-sm">All Equipment Included</p>
                      <p className="text-stone-500 text-xs">Walk in and start creating</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
